import { Button, Modal, ModalBody } from "react-bootstrap";

const CommonUpgradePop = ({ show, title, description, mediaUrl, onUpgradeClick, onCloseClick, mediaType = "image", btnText = "Upgrade Now", size = "lg", containerId = null, backdrop = true, btnLoading = false }) => {
    return <Modal container={containerId} show={show} onHide={onCloseClick} size={size} aria-labelledby="contained-modal-title-vcenter" centered backdrop={backdrop}>
            <ModalBody className="p-md-5 p-4 photobooth-popup-body">
                <div className="row align-itmes-center">
                    {title ? <h2 className="font-weight-boldest w-100 text-center mt-0 mb-2">{title}</h2> : null}
                    {description ? <p className="mb-4 text-center">{description}</p> : null}
                    <div className="col-lg-12">
                        <div className="switch_image ugc-switch-video mb-3 w-100">
                            {mediaType == "video" ? <video className={`img-fluid`} autoPlay id="audioTag" loop playsinline muted>
                                <source src={mediaUrl} type="video/mp4" />
                            </video> : <img className='w-100' src={mediaUrl} alt="upgrade" />}
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="switch_text_inner text-center">
                            <Button variant="primary" size="lg" onClick={onUpgradeClick} className={`btn-min-w mt-2`} disabled={btnLoading}>
                                {btnLoading ? <span>Please wait...<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span> : btnText}
                            </Button>
                        </div>
                    </div>
                </div>
            </ModalBody>
        </Modal>
}

export default CommonUpgradePop;